import { render, staticRenderFns } from "./CommonHotRanking.vue?vue&type=template&id=5a693d6d&scoped=true"
import script from "./CommonHotRanking.vue?vue&type=script&lang=js"
export * from "./CommonHotRanking.vue?vue&type=script&lang=js"
import style0 from "./CommonHotRanking.vue?vue&type=style&index=0&id=5a693d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a693d6d",
  null
  
)

export default component.exports